try {
require.config({
	"paths": {
		"jQuery": "jquery-1.11.1.custom",
		"jasmine-ajax": "mock-ajax",
		"Backbone": "backbone.custom",
		"Backbone.Validation": "backbone-validation",
		"jQuery.bxSlider": "jquery.bxslider.custom",
		"Handlebars": "handlebars.runtime-v4.0.10",
		"typeahead": "typeahead.bundle"
	},
	"shim": {
		"jQuery": {
			"exports": "jQuery"
		},
		"json2": {
			"exports": "JSON"
		},
		"jquery.zoom": {
			"deps": [
				"jQuery"
			]
		},
		"jQuery.bxSlider": {
			"deps": [
				"jQuery"
			]
		},
		"bootstrap": {
			"deps": [
				"jQuery"
			]
		},
		"bootstrap-datepicker": {
			"deps": [
				"jQuery",
				"bootstrap"
			]
		},
		"Backbone.Validation": {
			"deps": [
				"Backbone"
			]
		},
		"typeahead": {
			"deps": [
				"jQuery"
			]
		}
	},
	"map": {
		"jquery.cookie": {
			"jquery": "jQuery"
		}
	},
	"findNestedDependencies": true
});
var SCShoppingStarter= true;
}
catch(e){};
define("shopping", function(){});

